module.exports = __webpack_public_path__ + "media/images/image_themelist_new-823b4390789931308cbd148cfe017a2d.png";